import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../networking/client';
import { RootState } from '../store';

export interface ICountry {
  country_id: number;
  country_phone_code: string;
  countrycode: string;
  country: string;
}

export interface ICountriesState {
  status: string;
  countries: ICountry[];
}

const initialState: ICountriesState = {
  status: 'idle',
  countries: [],
};

export const fetchCountries = createAsyncThunk(
  'countries/fetchAll',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const countriesResponse: any = await client.get('/healthpoint/countries');
      return countriesResponse;
    } catch (err: any) {
      return rejectWithValue({});
    }
  }
);

export const countriesSlice = createSlice({
  name: 'countries',
  initialState,
  reducers: {
    resetCountries: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountries.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchCountries.fulfilled, (state, action) => {
        state.countries = action.payload.data.countries;
        state.status = 'idle';
      })
      .addCase(fetchCountries.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const { resetCountries } = countriesSlice.actions;

export default countriesSlice.reducer;

export const selectCountries = (state: RootState) => state.countries.countries;
